import { Modal, Button, Card, Divider, Tag } from 'antd';
import dayjs from 'dayjs';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  FaEye,
  FaUser,
  FaMoneyBillWave,
  FaDollarSign,
  FaTag,
  FaClock,
  FaCalendarAlt,
  FaInfoCircle,
  FaTimes,
  FaCheck,
} from 'react-icons/fa';
import { useStateContext } from '~/contexts/ContextProvider';

export default function DetailsRefundMobile({ data }) {
  const { formatMoney } = useStateContext();
  const { t } = useTranslation('report');
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const detailItems = [
    {
      icon: <FaUser className="text-blue-500" />,
      label: t('username'),
      value: data?.username,
      type: 'text',
    },
    {
      icon: <FaMoneyBillWave className="text-green-500" />,
      label: t('tongcuoc'),
      value: formatMoney(data?.total_bet),
      type: 'money',
    },
    {
      icon: <FaDollarSign className="text-emerald-500" />,
      label: t('sotien'),
      value: formatMoney(data?.amount),
      type: 'money',
    },
    {
      icon: <FaTag className="text-purple-500" />,
      label: t('tennhomhoantra'),
      value: data?.provider_code,
      type: 'tag',
    },
    {
      icon: <FaClock className="text-orange-500" />,
      label: t('thoigiantu'),
      value: data?.from,
      type: 'time',
    },
    {
      icon: <FaClock className="text-orange-500" />,
      label: t('thoigianden'),
      value: data?.to,
      type: 'time',
    },
    {
      icon: <FaCalendarAlt className="text-red-500" />,
      label: t('ngayhoantra'),
      value: dayjs(data?.created_at).format('DD-MM-YYYY HH:mm:ss'),
      type: 'datetime',
    },
  ];

  const renderValue = (item) => {
    switch (item.type) {
      case 'money':
        return (
          <span className="font-bold text-green-600 bg-green-50 px-2 py-1 rounded-lg">
            {item.value}
          </span>
        );
      case 'tag':
        return (
          <Tag color="purple" className="font-medium">
            {item.value}
          </Tag>
        );
      case 'datetime':
        return (
          <span className="text-gray-700 bg-gray-100 px-2 py-1 rounded-lg font-mono text-sm">
            {item.value}
          </span>
        );
      case 'time':
        return (
          <span className="text-orange-600 bg-orange-50 px-2 py-1 rounded-lg font-medium">
            {item.value}
          </span>
        );
      default:
        return <span className="font-medium text-gray-800">{item.value}</span>;
    }
  };

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        className="flex items-center justify-center bg-gradient-to-r from-blue-500 to-blue-600 border-none text-white hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl rounded-lg"
        icon={<FaEye />}>
        {/* {t("chi tiet")} */}
      </Button>

      <Modal
        open={open}
        closable={false}
        width={480}
        centered
        footer={null}
        className="custom-refund-modal"
        maskStyle={{
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          backdropFilter: 'blur(8px)',
        }}>
        <div className="bg-gradient-to-br from-white via-blue-50 to-indigo-100 rounded-2xl shadow-2xl  overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-orange-500 to-amber-600 text-white p-4 text-center flex justify-center gap-5">
            <FaInfoCircle className="text-2xl mb-2" />
            <h3 className="text-xl font-bold m-0">{t('chi tiet')} Hoàn Trả</h3>
          </div>

          {/* Content */}
          <div className="space-y-2 p-3">
            {detailItems.map((item, index) => (
              <div
                key={index}
                className="bg-white/80 backdrop-blur-sm rounded-xl p-2 shadow-md border border-white/40 hover:shadow-lg transition-all duration-300">
                <div className="flex items-center justify-between">
                  <div className="flex  items-center gap-3">
                    {item.icon}
                    <span className="font-medium text-gray-700">{item.label}</span>
                  </div>
                  <div className="text-right">{renderValue(item)}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Footer Buttons */}
          <div className="flex gap-3 justify-center mb-3 p-3">
            <Button
              onClick={handleClose}
              size="large"
              className="flex justify-center gap-5 items-center bg-gradient-to-r from-green-500 to-emerald-600 border-none text-white hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl rounded-xl px-8 font-semibold"
              icon={<FaTimes />}>
              {t('dong')}
            </Button>
            {/* <Button
              onClick={handleClose}
              size="large"
              className="bg-gradient-to-r from-gray-400 to-gray-500 border-none text-white hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl rounded-xl px-8 font-semibold"
              icon={<FaTimes />}
            >
              {t("dong")}
            </Button> */}
          </div>
        </div>

        <style jsx>{`
          .custom-refund-modal .ant-modal-content {
            background: transparent !important;
            box-shadow: none !important;
            padding: 0 !important;
            border-radius: 16px !important;
          }

          .custom-refund-modal .ant-modal-body {
            padding: 0 !important;
          }

          .custom-refund-modal .ant-modal-header {
            display: none !important;
          }

          .custom-refund-modal .ant-modal-close {
            display: none !important;
          }

          .custom-refund-modal .ant-divider {
            margin: 24px 0 !important;
            border-color: #e5e7eb !important;
          }

          /* Custom animations */
          @keyframes modalSlideIn {
            from {
              opacity: 0;
              transform: translateY(-20px) scale(0.95);
            }
            to {
              opacity: 1;
              transform: translateY(0) scale(1);
            }
          }

          .custom-refund-modal .ant-modal-content {
            animation: modalSlideIn 0.3s ease-out;
          }

          /* Mobile responsiveness */
          @media (max-width: 640px) {
            .custom-refund-modal {
              width: 95% !important;
              max-width: 400px !important;
            }

            .custom-refund-modal .space-y-4 > div {
              padding: 12px !important;
            }

            .custom-refund-modal .flex.gap-3 {
              flex-direction: column !important;
            }

            .custom-refund-modal .px-8 {
              padding-left: 24px !important;
              padding-right: 24px !important;
              width: 100% !important;
            }
          }

          /* Hover effects for detail items */
          .space-y-4 > div:hover {
            transform: translateY(-2px);
            background: rgba(255, 255, 255, 0.9) !important;
          }

          /* Button hover effects */
          .custom-refund-modal button:hover {
            transform: scale(1.05) !important;
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15) !important;
          }

          /* Scrollbar styling */
          .custom-refund-modal ::-webkit-scrollbar {
            width: 6px;
          }

          .custom-refund-modal ::-webkit-scrollbar-track {
            background: #f1f5f9;
            border-radius: 3px;
          }

          .custom-refund-modal ::-webkit-scrollbar-thumb {
            background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
            border-radius: 3px;
          }

          .custom-refund-modal ::-webkit-scrollbar-thumb:hover {
            background: linear-gradient(135deg, #d97706 0%, #b45309 100%);
          }
        `}</style>
      </Modal>
    </>
  );
}
